var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.content.length)?_c('BlockContent',{attrs:{"data":_vm.data}},[_c('render-content')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }